import "./announcement.scss";
import { Box, Button, Snackbar, Alert, Chip, FormGroup, FormControlLabel, Switch, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteRequest, getRequestWithToken } from "../../utils/ApiRequests";
import { GlobalContext } from "../../components/GlobalStateProvide/GlobalStateProvider";
import ReusableLoader from "../../components/ReusableLoader/ReusableLoader";
import SureYouWantToDeletModal from "../../components/SureYouWantToDeleteModal/SureYouWantToDeletModal";
import { checkPermission } from '../../utils/userPermissions'
import Unauthorized from "../../components/unauthorized/Unauthorized";


const Jsk = () => {
  const [jskData, setJskData] = useState([]);
  const [jwpDeleted, setJwpDeleted] = useState(false);
  const navigate = useNavigate();
  const { handleSnackBar } = useContext(GlobalContext);
  const [showLoader, setShowLoader] = useState(true);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [candidateId, setCandidateId] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [loadingDataInGrid, setLoadingDataInGrid] = useState(true);
  const [canCreate, setCanCreate] = useState(true);
  const [canDelete, setCanDelete] = useState(true);
  const [canUpdate, setCanUpdate] = useState(true);
  const [canRead, setCanRead] = useState(true);

  const [isAccess, setisAccess] = useState([]);
  const [isIncludesValue, setisIncludesValue] = useState(true);

  const [showDeletedRows, setShowDeletedRows] = useState(true);

  const filteredRows = showDeletedRows
    ? jskData
    : jskData.filter(jwp => jwp.hasOwnProperty('deleted') && jwp.deleted.is_deleted === false);


  const columns = [
    {
      field: 'id',
      headerName: 'S.No.',
      width: 70,
      renderCell: (params) => {
        let addNumber = pageNumber * pageSize;
        let rowIndex = params.api.getRowIndex(params.row._id);
        return (<span>{rowIndex + 1 + addNumber}</span>)
      },
    },

    {
      field: 'firstName',
      headerName: 'Name',
      width: 200,
      valueGetter: (params) => {
        const { firstName = "", middleName = "", lastName = "" } = params.row;
        const fullName = `${firstName} ${middleName} ${lastName}`;
        return fullName;
      },
    },

    {
      field: 'phone',
      headerName: 'Phone',
      width: 200,
    },

    {
      field: 'email',
      headerName: 'Email',
      width: 250,
    },

    {
      field: 'shopName',
      headerName: 'Shop Name',
      width: 250,
      valueGetter: (params) => (params.row?.shopName ? params.row?.shopName : "--"),
    },

    {
      field: 'createdAt',
      headerName: 'Created At',
      width: 200,
      valueGetter: (params) => (new Date(params.value).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }))
    },
    // {
    //   field: 'jobShayak',
    //   headerName: 'Job Shayak',
    //   width: 250,
    //   valueGetter: (params) => (params.row?.jobSahayak ? params.row?.jobSahayak : "--"),
    // },
    {
      field: 'action',
      headerName: 'Action',
      width: 150,
      renderCell: (params) => {
        return (
         <Box style={{ display: "flex", gap: "2rem" }}>
          {canUpdate ? (<Tooltip title="Edit" >
                <EditIcon sx={{ cursor: "pointer" }} color="primary" onClick={() => navigate("/jsk/create", {
                  state: params.row,
                })} />
              </Tooltip>) : ""}
          {/* {canUpdate && <Button color="info" variant="contained" onClick={() => navigate("/jsk/assign-josahayak", {
                  state: params.row,
                })} 
            > {params.row.jobSahayak !== "" ? "Reassign Jobsahayak" : "Assign JobSahayak"} </Button>} */}
          </Box >
        );
      },

    },

  ];

  const getAllJsk = async () => {
    try {
      let response = await getRequestWithToken(`admin/job-seva-kendra?page=${parseInt(pageNumber + 1)}&limit=${pageSize}`);
      setRowCount(response?.data?.totalCount);
      setJskData(response.data.data);
      // console.log(response.data.data)
      setLoadingDataInGrid(false);
      setShowLoader(false);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg || error?.message, "error");
      setLoadingDataInGrid(false);
      setShowLoader(false);
    }

  }

  const checkPermissionFunc = () => {
    const resourceToUpdate = "Jobseva";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate)
    setCanDelete(permissions.canDelete)
    setCanUpdate(permissions.canUpdate)
    setCanRead(permissions.canRead)
  }

  const againCheckPermissions = () => {
    // console.log("hello")
    const checkAccesInArray = localStorage.getItem("resourceNames");
    // console.log("resourceNames : " + checkAccesInArray);
    setisAccess(checkAccesInArray);
    isIncludes();
  }

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes("Jobseva"))
  }

  useEffect(() => {
    getAllJsk();
    checkPermissionFunc();
    againCheckPermissions();
  }, [pageSize, pageNumber, isIncludesValue])

  const createNewJSK = () => {
    navigate('/jsk/create');
  }
  return ((isIncludesValue) ?
    <Box className="employers-section">
      <Box className="employers-top-section" style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
      }}>
          {canCreate ? (<Button variant="contained" color="success" onClick={createNewJSK}>
            Create JSK
          </Button>) : ""}
      </Box>

      <Box className="employers-data">
        {showLoader ? <ReusableLoader /> : <DataGrid
          rowCount={rowCount}
          pagination
          rows={filteredRows}
          columns={columns}
          getRowId={(jskData) => jskData._id} //
          paginationMode="server"
          rowsPerPageOptions={[10, 20, 30, 50, 100]}
          page={pageNumber}
          pageSize={pageSize}
          onPageChange={(newPage) => { setLoadingDataInGrid(true); setPageNumber(newPage) }}
          onPageSizeChange={(newPageSize) => { setLoadingDataInGrid(true); setPageSize(newPageSize); }}
          loading={loadingDataInGrid}

        />}
      </Box>
      <SureYouWantToDeletModal
        modalTitle=""
        dialogBody="Are you sure you want to delete this user"
        buttonText="Yes"
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        onYesClick={() => {
          // deleteJwp();
        }}
      />
    </Box> : (<Unauthorized />)
  )
}
export default Jsk;
